module.exports = __webpack_public_path__ + "static/media/how-seo-illustr-1.74d012f3.png";